// extracted by mini-css-extract-plugin
var _1 = "radio-switcher-list__kMguA";
export { _1 as "radio-switcher-list" }
